export default __webpack_public_path__ + "static/media/526p.33b0a526.svg";